export const ERROR_401_ILUSTRATION =
  'https://tenecesito-bucket.s3.us-west-1.amazonaws.com/static/assets/errorIlustrations/error_401.png';

export const ERROR_403_ILUSTRATION =
  'https://tenecesito-bucket.s3.us-west-1.amazonaws.com/static/assets/errorIlustrations/error_403.png';

export const ERROR_404_ILUSTRATION =
  'https://tenecesito-bucket.s3.us-west-1.amazonaws.com/static/assets/errorIlustrations/error_404.png';
